// Modules
import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import Container from "../../atoms/Container";
import Typography from "../../atoms/Typography";

// Styles
import colors from "../../theme/colors";

// Types
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const GameShortDescription = props => {
  const {
    title = '',
    description = '',
    mainImage = '',
    nextImage,
    id
  } = props;
  const refContainer = useRef();

  // dispatchEvent event send id to sub navigation
  useEffect(() => {
    if (typeof window !== "undefined") {
      const container = refContainer.current;
      // const height = window.innerHeight;
      window.addEventListener("scroll", () => {
        if (container) {
          const {
            bottom,
            top
          } = container.getBoundingClientRect();
          const newBottom = Math.floor(bottom);
          const newTop = Math.floor(top);
          if (newTop < 120 && newBottom > 100) {
            // refIsShow.current = true;
            window?.dispatchEvent(new Event(`${id}`));
          }
        }
      });
    }
    return () => {
      window.removeEventListener(`${id}`, () => {});
      window.removeEventListener(`scroll`, () => {});
    };
  }, [id]);
  return /*#__PURE__*/_jsx(Box, {
    id: id,
    ref: refContainer,
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: "column",
          width: "100%"
        },
        children: /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              padding: {
                xs: "0px 16px",
                md: "0px"
              }
            },
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "h2",
              sx: {
                padding: {
                  xs: "0px",
                  lg: "0px 76px",
                  xl: "0px 177px"
                },
                width: "100%",
                color: colors.primary.bandaiNamcoBlack,
                lineHeight: {
                  xs: "36px",
                  md: "58px"
                },
                letterSpacing: {
                  md: "-1px",
                  xs: '-0.4px'
                },
                wordBreak: 'break-word'
              },
              children: title
            })
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              maxWidth: '100%',
              width: "100%",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              margin: {
                xs: '36px 0',
                lg: '56px 0'
              },
              paddingBottom: "56.2%",
              borderRadius: {
                xs: '10px',
                md: "20px"
              },
              overflow: "hidden",
              "& span": {
                position: "absolute !important",
                top: "0px",
                left: "0px",
                width: "100% !important",
                height: "100% !important"
              },
              '& img': {
                position: "absolute",
                top: "0px",
                left: "0px",
                objectFit: 'cover',
                display: 'block',
                width: '100%',
                height: '100%',
                marginLeft: {
                  xs: '0',
                  lg: '0px'
                }
              }
            },
            children: nextImage || /*#__PURE__*/_jsx("img", {
              src: mainImage,
              alt: title ?? ''
            })
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              gridColumn: '2/3',
              gridRow: '-2/-1',
              padding: {
                xs: '0px 16px',
                md: "0px",
                lg: '0 95px 0 474px'
              }
            },
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "p6",
              sx: {
                color: colors.neutral.neutral2,
                wordBreak: 'break-word'
              },
              children: description
            })
          })]
        })
      })
    })
  });
};
export default GameShortDescription;